import script from "./ShopView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopView.vue?vue&type=script&lang=ts&setup=true"

import "./ShopView.vue?vue&type=style&index=0&id=6173eb7a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6173eb7a"]])

export default __exports__